import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './Home';
import Category from './Category';

const Routes = (props) => (
  <Switch>
    <Route exact path="/" render={() => <Home {...props} />} />
    <Route
      exact
      path="/information"
      render={() => (
        <Category {...props} name="Information" filter="information" />
      )}
    />
    <Route
      exact
      path="/inspiration"
      render={() => (
        <Category {...props} name="Inspiration" filter="inspiration" />
      )}
    />
    <Route
      exact
      path="/instruction"
      render={() => (
        <Category {...props} name="Instruction" filter="instruction" />
      )}
    />
    <Route exact path="*" render={() => <p>Not Found</p>} />
  </Switch>
);

export default Routes;
